<template>
  <div class="container4">
    <div class="leftmap">
      
      <div class="plugin">
          <div :class="{'pbtn':true, 'activebtn':'vector'=== currentMapLayer.type}" @click="toggleMapType('vector')">矢量地图</div>
          <div :class="{'pbtn':true, 'activebtn':'satellite'=== currentMapLayer.type}" @click="toggleMapType('satellite')">影像地图</div>
      </div>
      <div class="distance-plugin">
          <div :class="{'pbtn':true, 'activebtn':isDistanceMode}" @click="toggleDistanceMode">测距</div>
          <div v-if="isDistanceMode" :class="{'pbtn':true}" @click="clearDistanceMeasurement">清除</div>
      </div>
      <l-map
        ref="map"
        style="width: 100%; height: 100%; z-index: 10"
        :zoom="zoom"
        :center="center"
        @zoomend="updateClusters"
      >
         <l-tile-layer :url="currentMapLayer.url" ></l-tile-layer>
         <l-tile-layer :url="currentMapLayer.texturl" :attribution="currentMapLayer.attribution"></l-tile-layer>

   

        <l-polygon v-for="polygon in polygonPath"  :lat-lngs="polygon.path" 
         :fill-color="polygon.filecolor" :fill-opacity="polygon.fillopacity" 
          :visible="polygon.hide"
          :color="polygon.filecolor"></l-polygon>


         <!-- 显示聚合点 -->
     <l-marker v-for="item in clusters" :key="item.id" :lat-lng="item.latlng"   @click="zoomToCluster(item)" >
      <l-icon >
        <div class="custom-cluster">
          {{ item.count }}
        </div>
      </l-icon>
    </l-marker>



        <l-marker
        
          v-for="item in visibleMarkers"
          :key="item.id"
          :icon="icon(item.usecate)"
          :lat-lng="[item.lat_gaode, item.lng_gaode]"
          :offset="[8, 0]"
        >
          
          <l-tooltip
            :options="{
              permanent: true,
              interactive: true,
              offset: [4, -16],
              className: 'color' + item.usecate,
            }"
          
          >
            <div class="title"  @click="handleRowClick(item)">
              {{
                item.locationnum ||
                item.noticenum ||
                item.locationname ||
                item.location
              }}
            </div>
          </l-tooltip>
      
        </l-marker>
    

        <!-- 当前地块的多边形 -->
        <l-polygon
          v-for="item in currentPolygonpath"
          :key="item.id"
          :lat-lngs="item.path"
          :color="item.strokeColor"
          :fill-color="item.filecolor"
          :fill-opacity="1"
        >
        
        </l-polygon>

        
      </l-map>

    </div>

  </div>
</template>

<script>



import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LPolyline,
  LTooltip,
  LPolygon,
  LIcon,
} from "vue2-leaflet";
// import LMarkerCluster from 'vue2-leaflet-markercluster';
import { vectorMapLayer,satelliteMapLayer,leafletmapurl,leafletmaptexturl,leafletmapyunxuanurl, isgaode } from "@/settings.js";

import { latLng,icon } from "leaflet";


import { getDetail,cityLand } from "@/api/website/collect.js";


export default {
  name: "FrontendPcBigdataLandlayout",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LPolyline,
    LPolygon,
    LIcon,
    LTooltip,
    // LMarkerCluster
  },
  props: {
    select_city_id:0,
    is_chan:0
  },

 
  data() {
    return {
      polygonPath:[],
      markerdata: [],
      currentPolygonpath: [],
      crs: L.CRS.EPSG3857, // 使用的是EPSG:3857坐标系
      url: leafletmapurl,
      attribution: "",
       //矢量地图对象
      vectorMapLayer:vectorMapLayer ,
      //卫星地图数据对象
      satelliteMapLayer: satelliteMapLayer,
      //当前地图图层
      currentMapLayer:{url:'',texturl:'',attribution:'',type:'vector'},
      staticAnchor: [16, 37],
      center: [0, 0],
      zoom: 16,
      count: 0,
      isIndeterminate: true,
      id: 0,
      map: {},
      detail: {},
      mapdata:[],
      clusters:[],
      visibleMarkers:[],
      clusterdata:[
        
      
      ],
      isDistanceMode: false, // 测距模式状态
      distanceControl: null, // 测距控制器
      distanceMarkers: [], // 测距过程中创建的标记
      distancePolyline: null, // 测距过程中创建的折线
      distanceTooltip: null // 测距过程中创建的tooltip
    };
  },

  watch: {
     is_chan: {
      handler(nv, ov) {
        this.getAroundLand()
      },
      deep: true,
    },
    select_city_id: {
     handler(nv, ov) {
        this.getAroundLand()
      },
      deep: true,
    },
    mapdata: {
      handler(nv, ov) {
        this.markerdata = nv
        this.handerPolygondata(nv);

      },
      deep: true,
    },


  },

  computed: {


  },

  mounted() {

  
        this.getAroundLand()
   
  },
  
  created() {
     this.id = this.$route.params.id;
     this.currentMapLayer = this.vectorMapLayer;
     this.currentMapLayer.type = 'vector'
  },


  methods: {

     zoomToCluster(cluster) {
      if (this.$refs.map) {
        this.$refs.map.mapObject.flyTo(cluster.latlng, this.$refs.map.mapObject.getZoom() + 2);
      }
    },

     updateClusters() {
      if (this.$refs.map && this.$refs.map.mapObject) {
        const map = this.$refs.map.mapObject;
        const zoom = map.getZoom();
     
        
        // 在高级别缩放时显示所有点
        if (zoom > 12) {
         
          this.clusters = [];
             console.log('点的全部的数据是',this.mapdata)
          this.visibleMarkers = this.mapdata;
     
        }else{
          
           // 否则执行聚合逻辑
            this.visibleMarkers = [];
            console.log('聚合的数据是',this.clusterdata)
            this.clusters = this.clusterdata ;
        }
        
     
      }
    },




      handleRowClick(row, event, column) {
        console.log(row);
        if(this.is_preview){
           window.open('/#/preview/landdetail/'+row.id+'/'+this.id)
        }else{
           window.open('/#/collect/landdetail/'+row.id+'/'+this.id)
        }     
    },

    handerPolygondata(polygondata) {
      let polygonpath = [];
      const pointobj = polygondata.map((item) => {
      const allset = item.set_gaode; //所有多边形
      if (item.set_gaode) {
        const setObj = JSON.parse(allset);
        const rowpolygonpath = setObj.map((itemSingle) => {
          // data 是一个多变形的数据
          // 处理一个多变形的方法
          const singlepath = this.handleSingleData(item.id, itemSingle);
          polygonpath.push(singlepath);
        });
      }
    });

   
    this.polygonPath = polygonpath;
    setTimeout(() => {
      this.zoom = 12;
    }, 1000);
  },


    getAroundLand(){

      //获取边界条件
      const params = {
        select_city_id:this.select_city_id,
        id:this.id,
        is_gaode:isgaode,
        is_chan:this.is_chan,
      };

      cityLand(params).then((res) => {
          this.mapdata = res.data.list
          this.center = [res.data.center.lat_gaode, res.data.center.lng_gaode];
          this.clusters = res.data.clusterdata;
          this.clusterdata = res.data.clusterdata;
      })
    },
     toggleMapType(type) {
      if (type === 'vector') {
        this.currentMapLayer = this.vectorMapLayer;
        this.currentMapLayer.type = 'vector'
      } else if (type === 'satellite') {
        this.currentMapLayer = this.satelliteMapLayer;
        this.currentMapLayer.type = 'satellite'
      }
    },
    toggleDistanceMode() {
      this.isDistanceMode = !this.isDistanceMode;
      const map = this.$refs.map.mapObject;
      
      if (this.isDistanceMode) {
        // 初始化测距控制器
        if (!this.distanceControl) {
          // 检查是否已经加载了Leaflet.MeasureControl插件
          if (typeof L.Control.Measure !== 'undefined') {
            this.distanceControl = new L.Control.Measure({
              position: 'topright',
              primaryLengthUnit: 'kilometers',
              secondaryLengthUnit: 'meters',
              primaryAreaUnit: 'sqkilometers',
              secondaryAreaUnit: 'hectares',
              activeColor: '#3388ff',
              completedColor: '#3388ff'
            });
            this.distanceControl.addTo(map);
          } else {
            // 如果没有插件，使用简单的测距方法
            this.startDistanceMeasurement();
          }
        } else {
          this.distanceControl.addTo(map);
        }
      } else {
        // 移除测距控制器
        if (this.distanceControl) {
          map.removeControl(this.distanceControl);
        }
      }
    },
    clearDistanceMeasurement() {
      const map = this.$refs.map.mapObject;
      
      // 移除所有测距标记
      for (let marker of this.distanceMarkers) {
        map.removeLayer(marker);
      }
      this.distanceMarkers = [];
      
      // 移除测距折线
      if (this.distancePolyline) {
        map.removeLayer(this.distancePolyline);
        this.distancePolyline = null;
      }
      
      // 移除测距tooltip
      if (this.distanceTooltip) {
        map.removeLayer(this.distanceTooltip);
        this.distanceTooltip = null;
      }
      
      // 移除地图点击事件
      map.off('click');
      map.off('dblclick');
    },
    startDistanceMeasurement() {
      const map = this.$refs.map.mapObject;
      let points = [];
      
      // 清除之前的测距元素
      this.clearDistanceMeasurement();
      
      const onMapClick = (e) => {
        points.push(e.latlng);
        
        if (points.length === 1) {
          // 第一次点击，添加起点标记
          const startMarker = L.marker(points[0], {
            icon: L.divIcon({
              className: 'start-marker',
              html: '<div style="background: #4CAF50; color: white; width: 20px; height: 20px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px;">起</div>',
              iconSize: [20, 20],
              iconAnchor: [10, 10]
            })
          }).addTo(map);
          startMarker.bindPopup('起点').openPopup();
          this.distanceMarkers.push(startMarker);
        } else {
          // 后续点击，更新折线
          if (this.distancePolyline) {
            map.removeLayer(this.distancePolyline);
          }
          
          this.distancePolyline = L.polyline(points, {color: 'blue'}).addTo(map);
          
          // 计算距离
          let totalDistance = 0;
          for (let i = 1; i < points.length; i++) {
            totalDistance += points[i-1].distanceTo(points[i]);
          }
          
          // 显示距离
          const distanceText = (totalDistance / 1000).toFixed(2) + ' 公里';
          
          if (this.distanceTooltip) {
            map.removeLayer(this.distanceTooltip);
          }
          this.distanceTooltip = L.tooltip({
            permanent: true,
            direction: 'top',
            className: 'distance-tooltip'
          })
          .setContent(distanceText)
          .setLatLng(e.latlng)
          .addTo(map);
        }
      };
      
      const onMapDblClick = (e) => {
        // 双击结束测量
        map.off('click', onMapClick);
        map.off('dblclick', onMapDblClick);
        
        if (points.length > 1) {
          // 添加终点标记
          const endMarker = L.marker(points[points.length - 1], {
            icon: L.divIcon({
              className: 'end-marker',
              html: '<div style="background: #f44336; color: white; width: 20px; height: 20px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px;">终</div>',
              iconSize: [20, 20],
              iconAnchor: [10, 10]
            })
          }).addTo(map);
          endMarker.bindPopup('终点').openPopup();
          this.distanceMarkers.push(endMarker);
        }
        
        // 重置状态
        points = [];
      };
      
      // 绑定事件
      map.on('click', onMapClick);
      map.on('dblclick', onMapDblClick);
    },
    icon(num) {
      if (num == null || num == "") {
        return icon({
          iconUrl: require("@/assets/opcity.png"),
          iconSize: [32, 37],
          iconAnchor: [16, 37],
        });
      } else {
        return icon({
          iconUrl: require("@/assets/type" + num + ".png"),
          iconSize: [32, 37],
          iconAnchor: [16, 37],
        });
      }
    },


    




 


    handercurrentPolygondata(id, allset) {
      let currentPolygonpath = [];
      const setObj = JSON.parse(allset);
      console.log("setObj", setObj);
      const rowcurrentPolygonpath = setObj.map((itemSingle) => {
        // data 是一个多变形的数据
        // 处理一个多变形的方法
        const singlepath = this.handleSingleData(id, itemSingle);
        currentPolygonpath.push(singlepath);
      });
      this.currentPolygonpath = currentPolygonpath;
    },

    handleSingleData(id, data) {
      let obj = {
        id: id,
        path: [],
        filecolor: "#000",
        strokcolor: "#409EFF",
        weight: this.strokeWeight,
        strokeopacity: this.strokeOpacity,
        fillopacity: this.fillOpacity,
      };
      const pointobj = data.lnglat.split(";");
      const pointArr = pointobj.map((point) => {
        const lnglat = point.split(",");
        return [parseFloat(lnglat[1]), parseFloat(lnglat[0])];
      });
      obj.path = pointArr;
      obj.filecolor = data.color;

      return obj;
    },

  },
};
</script>

<style lang="scss"  scoped>

.title {
  font-size: 12px;
  width: auto;
}
.currenttitle{
  font-size:14px;
  font-weight:bold;
  background:rgb(10, 223, 98);
  color:#FFF;
  z-index: 10000;
}
.colortooltip{
   z-index: 10000;
}

.detailbox {
  display: flex;
  flex-direction: column;
  .tltlecon {
    font-size: 16px;
    font-weight: bold;
    margin: 10px;
  }
  .line {
    display: flex;
    flex-direction: row;
    line-height: 20px;

    .left {
      font-size: 12px;
      width: 30%;
      margin-left: 1%;
      height: 100%;
      overflow: hidden;
      background: #fff;
      padding-left: 5px;
      display: flex;
      flex-direction: column;
    }
    .right {
      font-size: 12px;
      width: 70%;
      height: 100%;
      overflow: hidden;
      background: #fff;
      padding-left: 5px;
      display: flex;
      flex-direction: column;
    }
  }
  .more {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
    color: #28a7e1;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn {
      width: 200px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      color: #fff;
      background: #28a7e1;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}

.plugin{
  height:0px;
  width:120px;
  display: flex;
  background: #fff;
  position: relative;
  float: left;
  top:20px;
  z-index: 1000;
  left:60px;
  .pbtn{
    width:60px;
    height:20px;
    color:#000;
    font-weight: bold;
    line-height: 20px;
    background: #fff;
    border: solid 1px #FFF;
    cursor: pointer;
  }
  .activebtn{
    color:#1384cf;
    border: solid 1px #1384cf;
  }
}

.distance-plugin{
  height:0px;
  width:120px;
  display: flex;
  background: #fff;
  position: relative;
  float: right;
  top:20px;
  z-index: 1000;
  right:60px;
  .pbtn{
    width:60px;
    height:20px;
    color:#000;
    font-weight: bold;
    line-height: 20px;
    background: #fff;
    border: solid 1px #FFF;
    cursor: pointer;
  }
  .activebtn{
    color:#1384cf;
    border: solid 1px #1384cf;
  }
}

.distance-tooltip {
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
}


/* 隐藏国企以及版权标识 */
::v-deep .leaflet-control-attribution,
.leaflet-control {
  display: none !important;
}

.tooltipInnerBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .icon {
    height: 30px;
    width: 30px;
  }
  .title {
    font-size: 16px;
    margin-left: 5px;
  }
}

.drawing-panel {
  position: absolute;
  right: 100px;
  top: 10px;
  height: 40px;
  width: 200px;
  background: "#fff";
  padding: 0px;
  z-index: 12;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rightlist {
  margin-top: 10px;
  width: 244px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .toplist {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #f0f3f8;
    padding-bottom: 10px;

    .toptitle {
      margin: 10px 0;
      width: 72px;
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 25px;
    }

    .topcon {
      width: 224px;
      background: #f0f3f8;
      border-radius: 4px;
      display: flex;
      flex-direction: column;

      .topitem {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        margin: 6px 0;

        .switch {
          width: 30px;
        }

        .iconbox {
          width: 156px;
          height: 52px;
          background: #ffffff;
          border-radius: 4px;
          display: flex;
          justify-content: space-around;
          align-items: center;

          .iconimg {
            width: 32px;
            height: 32px;
          }

          .iconcatename {
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #43496a;
            line-height: 16px;
          }
        }
      }
    }
  }

  .bottomlist {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: #f0f3f8;
    padding-bottom: 10px;
    width: 100%;
    flex: 1;

    overflow-y: scroll;

    .bottomlistinner {
      // background: red;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      justify-content: flex-start;
      margin-left: 15px;
      margin-top: 15px;

      .btitle {
        height: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 17px;
      }

      .bitem {
        text-align: left;
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 17px;
        display: block;
      }
    }
  }
}

.container4 {
  width: 100%;
  height: 700px;
  color: #333;
  display: flex;
  flex-direction: row;
}

.leftmap {
  // display: flex;
  width: 100%;
  border-radius: 0px;
  overflow: hidden;
  height: 100%;
  position: relative;

  .bmap-demo {
    flex: 1;
  }
}

.labelbox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  border-radius: 5px;

  .labelcontent {
    border: solid 1px #fff;
    background: #fff;
    border-radius: 4px;
    color: #333;
    font-size: 14px;
    padding: 4px;
    display: flex;
    flex-direction: row;
    padding: 5px 10px;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 0 10px #06c;

    .iconimg {
      height: 30px;
      width: 30px;
    }

    .labeltext {
      margin-left: 10px;
    }

    // mar
  }

  .labeldown {
    margin-left: 15px;
    width: 0;
    height: 0;
    border-top: 10px solid #fff;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
  }
}

.custom-cluster {
  background: rgba(5, 199, 108, 0.7);
  height:100px;
  width:100px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(255, 255, 255);
  font-weight: bold;
  cursor: pointer;
  z-index:300000;
}
</style>